import React from 'react';

import './CustomValue.css';

export default class CustomValue extends React.Component {
    render() {
        return <span className="custom-value">{this.props.children}</span>;
    }
}



// WEBPACK FOOTER //
// ./src/modules/form/components/custom-value/CustomValue.jsx